module.exports = __webpack_public_path__ + "img/navbar1.8b6dde62.png";